import React from "react";
import { Reveal } from "./Reveal";
const tomos = [{
  num: "I",
  title: "Crea tus Primeras Sales de Baño™",
  hook: "El primer paso para convertir una idea en un producto real.",
  text: "Aprende qué ingredientes necesitas, para qué sirve cada uno, cómo combinarlos correctamente y cómo preparar tus primeras sales de baño de forma sencilla, incluso si nunca antes has elaborado un producto artesanal."
}, {
  num: "II",
  title: "Diseña una Colección que Enamore™",
  hook: "No vendas un solo producto. Crea una colección que invite a comprar más.",
  text: "Descubre cómo organizar diferentes variedades de sales de baño para que tu marca luzca completa desde el primer día y genere una mayor percepción de valor."
}, {
  num: "III",
  title: "Crea una Marca que Inspire Confianza™",
  hook: "Haz que tus productos parezcan una marca profesional desde el primer vistazo.",
  text: "Aprende a crear el nombre, la personalidad, los colores y la identidad visual de tu marca sin contratar diseñadores."
}, {
  num: "IV",
  title: "Diseña un Packaging que Venda por Ti™",
  hook: "Porque las personas compran primero con los ojos.",
  text: "Aprende a elegir envases, etiquetas y presentaciones que hagan que tus productos transmitan calidad y aumenten su valor percibido."
}, {
  num: "V",
  title: "Ponle Precio y Prepárate para Vender™",
  hook: "Deja de adivinar cuánto cobrar y empieza a vender con seguridad.",
  text: "Aprende a calcular precios correctamente, organizar tus costos y preparar tu colección para salir al mercado."
}, {
  num: "VI",
  title: "Lanza tu Marca al Mundo™",
  hook: "Convierte todo tu trabajo en una marca lista para comenzar a vender.",
  text: "Descubre cómo presentar tu colección, mostrar tus productos de forma atractiva y dar tus primeros pasos para conseguir clientes."
}];
export function Tomos() {
  return <section className="w-full bg-white px-5 py-14" data-id="element-215" data-mp="280pjkfckjf72">
      <div className="mx-auto max-w-xl" data-id="element-216" data-mp="1zyzrp5actoar">
        <Reveal className="text-center" data-id="element-217" data-mp="2001e25wtlx7s">
          <p className="text-xs font-bold uppercase tracking-widest text-[#a04a63]" data-id="element-218" data-mp="1vyfvc3xluopo">
            Los 6 Tomos
          </p>
          <h2 className="mt-2 font-serif-display text-2xl font-semibold text-[#3d2b30] sm:text-3xl" data-id="element-219" data-mp="29yz0926rxenm">
            Tu hoja de ruta completa
          </h2>
          <p className="mt-3 text-sm text-[#6b565b] sm:text-base" data-id="element-220" data-mp="25177y727vqiw">
            Para lanzar tu primera línea de sales de baño.
          </p>
        </Reveal>

        <div className="mt-8 space-y-4" data-id="element-221" data-mp="2ew8xh40emum0">
          {tomos.map((t, i) => <Reveal key={t.num} delay={i * 0.04} data-id="element-222" data-mp="2soou9n2ppweh" data-mpi={i}>
              <div className="overflow-hidden rounded-2xl border border-[#e7d3d8] bg-[#fbf5f0]" data-id="element-223" data-mp="2sqjf71dzhoik">
                <div className="flex items-center gap-3 bg-[#a04a63] px-5 py-3 text-white" data-id="element-224" data-mp="2nrf7kf6pjyuc">
                  <span className="font-serif-display text-2xl font-bold leading-none" data-id="element-225" data-mp="32mutty11qqg6">
                    {t.num}
                  </span>
                  <span className="text-xs font-bold uppercase tracking-widest text-[#f0dbe1]" data-id="element-226" data-mp="3h9l963blujkr">
                    Tomo {t.num}
                  </span>
                </div>
                <div className="p-5" data-id="element-227" data-mp="3l8kie04dd2i0">
                  <h3 className="font-serif-display text-lg font-semibold leading-snug text-[#3d2b30]" data-id="element-228" data-mp="37bx8yxv8cjv7">
                    {t.title}
                  </h3>
                  <p className="mt-2 text-sm font-semibold italic text-[#a04a63]" data-id="element-229" data-mp="3cc1s6vnivsp4">{t.hook}</p>
                  <p className="mt-2 text-sm leading-relaxed text-[#6b565b]" data-id="element-230" data-mp="2xj826gamju67">{t.text}</p>
                </div>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}